"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isMS = exports.isIE = exports.isEdge = exports.hasTouch = void 0;
var isIE = function isIE() {
  if (typeof window !== "undefined" && window.navigator && window.navigator.userAgent) {
    var ua = window.navigator.userAgent;
    return ua.indexOf("MSIE ") !== -1 || ua.indexOf("Trident/") !== -1;
  }
  return false;
};
exports.isIE = isIE;
var isEdge = function isEdge() {
  if (typeof window !== "undefined" && window.navigator && window.navigator.userAgent) {
    var ua = window.navigator.userAgent;
    return ua.indexOf("Edge/") !== -1;
  }
  return false;
};
exports.isEdge = isEdge;
var isMS = function isMS() {
  return isIE() || isEdge();
};
exports.isMS = isMS;
var hasTouch = function hasTouch() {
  if (typeof window !== "undefined") {
    return "ontouchstart" in window;
  }
  return false;
};
exports.hasTouch = hasTouch;